import { createAView } from './createAView.tsx';
import { createIdeas } from './createIdeas.tsx';
import { exploreTheBasics } from './exploreTheBasics.tsx';
import { prioritizeAndPlan } from './prioritizeAndPlan.tsx';
import { shareAndCollaborate } from './shareAndCollaborate.tsx';
import { linkWorkItems } from './linkWorkItems.tsx';
import type { TaskDefinition } from './types.tsx';

export const allTasks: TaskDefinition[] = [
	exploreTheBasics,
	createIdeas,
	prioritizeAndPlan,
	createAView,
	shareAndCollaborate,
	linkWorkItems,
];
